export default __webpack_public_path__ + "static/Group 638-88f9ffc1bf37fa7584e7bd0ed4f8b295.png";